const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/meals/new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import * as z from 'zod';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { getDailyDashboardQuery } from '@/features/dashboard/lib/daily-dashboard.query';
import { isLocalDate } from '@/features/dashboard/lib/local-date';
import { listRecentLineIngredientsQuery } from '@/features/saved-meals/lib/list-recent-line-ingredients.query';
import { RECENT_LINE_INGREDIENTS_FETCH_LIMIT } from '@/features/saved-meals/lib/constants';

/** Legacy `?tab` links keep resolving: `manual` renders the page, `smart` redirects in `beforeLoad`. */
const mealsNewSearchSchema = z.object({
  tab: z.enum(['smart', 'manual']).optional().catch(undefined),
  date: z.string().refine(isLocalDate).optional().catch(undefined)
});
export const Route = createFileRoute('/_authenticated/tracking/meals/new')({
  validateSearch: mealsNewSearchSchema,
  beforeLoad: ({
    search
  }) => {
    if (search.tab === 'smart') {
      throw redirect({
        to: '/assistant/{-$conversationId}',
        params: {
          conversationId: undefined
        },
        replace: true
      });
    }
  },
  loaderDeps: ({
    search
  }) => ({
    date: search.date
  }),
  loader: async ({
    context,
    deps,
    location
  }) => {
    try {
      const dashboard = await context.queryClient.ensureQueryData(getDailyDashboardQuery({
        controllers: {
          dashboardController: context.deps.controllers.dashboardController
        },
        date: deps.date ?? null
      }));
      // Warms the Products tab's Recent list; not awaited so it never blocks the page.
      void context.queryClient.prefetchQuery(listRecentLineIngredientsQuery({
        controllers: {
          savedMealController: context.deps.controllers.savedMealController
        }
      }, RECENT_LINE_INGREDIENTS_FETCH_LIMIT));
      return dashboard;
    } catch (error) {
      return await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});